/* ---- the "More" menu --------------------------------------------------------------------------- */

.more {
  position: relative;
  display: inline-flex;
}

.moreButton {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  cursor: pointer;
}

.moreButton:hover {
  background: var(--panel-2);
}

.moreButton:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.moreList {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  min-width: 240px;
  padding: 4px;
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  background: var(--panel);
  box-shadow: var(--shadow-pop);
}

.moreList > div {
  display: flex;
  flex-direction: column;
}

.moreItem {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: var(--target-min);
  padding: 4px 10px;
  border: 0;
  border-radius: var(--radius-ctl);
  background: none;
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.moreItem:hover:not(:disabled) {
  background: var(--panel-2);
}

.moreItem:focus-visible {
  background: var(--panel-2);
  outline: 2px solid var(--focus);
  outline-offset: -2px;
}

.moreItem:disabled {
  color: var(--disabled);
  cursor: not-allowed;
}

.moreReason {
  margin-left: auto;
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 500;
}

/* ---- the drawers on the filing ------------------------------------------------------------------ */

.drawerBody {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.route {
  margin: 0;
  color: var(--ink);
  font-size: var(--t-body);
}

.routeLabel {
  color: var(--muted);
  font-weight: 600;
}

.quiet {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-dense);
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: var(--t-dense);
  font-weight: 600;
}

.reason {
  padding: 6px 9px;
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 400;
  color: var(--ink);
  background: var(--panel);
  border: 1px solid var(--line-2);
  border-radius: 6px;
  min-width: 0;
  resize: vertical;
}

.reason:focus-visible {
  border-color: var(--focus);
  outline: 2px solid var(--focus);
  outline-offset: 0;
}

.primary {
  min-height: var(--h-ctl);
  padding: 0 16px;
  border: 0;
  border-radius: var(--radius-ctl);
  background: var(--accent);
  color: var(--on-fill);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  cursor: pointer;
}

.primary:hover:not(:disabled) {
  background: var(--accent-h);
}

.primary:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.primary:disabled {
  background: var(--line-2);
  cursor: not-allowed;
}

.secondary {
  min-height: var(--h-ctl);
  padding: 0 16px;
  border: 1px solid var(--line);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  cursor: pointer;
}

.secondary:hover {
  background: var(--panel-2);
}

.secondary:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.link {
  font-size: var(--t-dense);
  font-weight: 600;
}

/* What an issue will freeze: a quiet box above the button, in the words of the verdict. */
.snapshot {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-ctl);
  background: var(--panel-2);
}

.snapshotLabel {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.snapshotText {
  color: var(--ink);
  font-size: var(--t-body);
  font-weight: 650;
}

.receiptList {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--t-dense);
  font-weight: 600;
}

/* ---- what this filing states -------------------------------------------------------------------- */

.stated {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 0 0 auto;
}

.statedHead {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.statedTitle {
  color: var(--ink);
  font-size: var(--t-body);
  font-weight: 650;
}

.statedRow {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: var(--gap);
}

.statedTile {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding: 12px 14px;
}

/* Two lines tall whether the label takes one or two, so the figures of a row of tiles share a baseline
   (the gate measures it: ui-check-alignment.mjs). */
.statedLabel {
  display: -webkit-box;
  min-height: 2.6em;
  overflow: hidden;
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
  line-height: 1.3;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.statedFigure {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 2px 6px;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  color: var(--ink);
  font: inherit;
  font-size: var(--t-figure);
  font-weight: 650;
  font-variant-numeric: lining-nums tabular-nums;
  line-height: var(--lh-24);
  text-align: left;
  text-decoration: underline;
  text-decoration-color: var(--line-2);
  text-underline-offset: 4px;
  cursor: pointer;
}

.statedFigure:hover {
  text-decoration-color: var(--accent);
}

.statedFigure:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.statedUnit {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 500;
}

.statedWord {
  color: var(--ink-2);
  font-size: var(--t-head);
  font-weight: 600;
  line-height: var(--lh-24);
}
